export const enum OnboardingIntakeTab {
    CUSTOMER_PROFILE = 1,
    SERVICE_REQUIREMENTS,
    COMMERCIAL_COMPLIANCE,
    REVIEW
}
